import {
  DASHBOARD_DETAILS,
  DASHBOARD_DETAILS_LOADER,
  IS_LOGIN,
  NOTIFICATION_DETAILS,
  NOTIFICATION_DETAILS_LOADER,
  PROFILE_DETAIL,
  PROFILE_DETAIL_LOADER,
  VERIFY_TOKEN,
} from "../actions/type";

const logedin = localStorage.getItem("authToken") ? true : false;
const initialState = {
  isLogin: logedin,
  verifyToken: {},
  profileDetails: {},
  profileDetailsLoader: false,
  dashboardDetails: {},
  dashboardDetailsLoader: false,
  notificationDetails: {},
  notificationDetailsLoader: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case IS_LOGIN:
      return {
        ...state,
        isLogin: payload,
      };
    case VERIFY_TOKEN:
      return {
        ...state,
        verifyToken: payload,
      };
    case PROFILE_DETAIL:
      return {
        ...state,
        profileDetails: payload,
        profileDetailsLoader: false,
      };
    case PROFILE_DETAIL_LOADER:
      return {
        ...state,
        profileDetailsLoader: payload,
      };

    case DASHBOARD_DETAILS:
      return {
        ...state,
        dashboardDetails: payload,
        dashboardDetailsLoader: false,
      };
    case DASHBOARD_DETAILS_LOADER:
      return {
        ...state,
        dashboardDetailsLoader: payload,
      };

    case NOTIFICATION_DETAILS:
      return {
        ...state,
        notificationDetails: payload,
        notificationDetailsLoader: false,
      };
    case NOTIFICATION_DETAILS_LOADER:
      return {
        ...state,
        notificationDetailsLoader: payload,
      };

    default:
      return state;
  }
}
